import { render, staticRenderFns } from "./scenarios.vue?vue&type=template&id=3438064a"
import script from "./scenarios.vue?vue&type=script&lang=js"
export * from "./scenarios.vue?vue&type=script&lang=js"
import style0 from "./scenarios.vue?vue&type=style&index=0&id=3438064a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports